<template>
	<div class="window window-error-browser" v-if="app.window.name == 'window-error-browser'">
		<div class="window-bg"></div>
		<div class="window-wrap">
			<div class="window-content">
					
				<div class="error-browser">
					<div class="main-icon"><icon file="frown" :size="70" /></div>
					<p><strong>L'application nécéssite l'utilisation du navigateur Google Chrome pour fonctionner.</strong></p>
					<br>
					<p>Vous utilisez actuellement Firefox, merci d'utiliser Chrome pour continuer.</p>
					<p class="small">
						Si Chrome n'est pas installé sur votre ordinateur, vous pouvez le <a href="https://www.google.fr/chrome/index.html">télécharger ici</a>.<br>
						Si vous ne savez pas comment faire, vous pouvez contacter le service informatique.
					</p>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "window-error-browser",
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters([ "app" ]),
	},
	methods: {
		close: function () {
			this.$store.dispatch("set_window", { name: false });
		}
	}
};
</script>


<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'
@import '../../assets/css/ui'
@import '../../assets/css/window'


.window.window-error-browser
	.window-content
		width 600px
	
	.error-browser
		padding 32px 0
		text-align center
		.main-icon
			margin 0 0 16px 0
			color red
		p
			strong
				color red
			&.small
				margin 32px 0 0 0
				padding 32px 0 0 0
				color #999
				font-size 11px
				&:before
					content ''
					position absolute
					left 50%
					top 0
					transform translate(-32px, -50%)
					height 2px
					width 64px
					background-color #ddd
				a
					color blue
					text-decoration underline
					&:hover
						text-decoration none

</style>